import React, { useState } from 'react';
import { api } from '../api';

const presets = {
  Gmail: {
    imapHost: 'imap.gmail.com',
    imapPort: 993,
    imapTls: true,
    smtpHost: 'smtp.gmail.com',
    smtpPort: 587,
    smtpTls: true,
  },
  Outlook: {
    imapHost: 'outlook.office365.com',
    imapPort: 993,
    imapTls: true,
    smtpHost: 'smtp.office365.com',
    smtpPort: 587,
    smtpTls: true,
  },
  Yahoo: {
    imapHost: 'imap.mail.yahoo.com',
    imapPort: 993,
    imapTls: true,
    smtpHost: 'smtp.mail.yahoo.com',
    smtpPort: 587,
    smtpTls: true,
  },
  Custom: {},
};

const field = (label, key, cfg, setCfg, type = 'text', placeholder = '') => (
  <div key={key} style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', color: 'var(--text1)', fontSize: 12, marginBottom: 4 }}>
      {label}
    </label>
    <input
      type={type}
      value={cfg[key] || ''}
      placeholder={placeholder}
      onChange={e => setCfg(p => ({ ...p, [key]: e.target.value }))}
    />
  </div>
);

export default function AddAccountModal({ onAdd, onClose }) {
  const [cfg, setCfg] = useState({ imapPort: 993, smtpPort: 587, imapTls: true, smtpTls: true });
  const [preset, setPreset] = useState('Gmail');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function applyPreset(name) {
    setPreset(name);
    setCfg(p => ({ ...p, ...presets[name] }));
  }

  async function submit() {
    setError('');
    setLoading(true);
    try {
      const acc = await api.addAccount(cfg);
      onAdd(acc);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const overlay = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100,
  };
  const modal = {
    width: 520,
    maxHeight: '90vh',
    overflowY: 'auto',
    background: 'var(--bg1)',
    border: '1px solid var(--line)',
    borderRadius: 10,
    padding: 32,
  };

  return (
    <div style={overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={modal}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 600 }}>Add Mail Account</div>
          <button onClick={onClose} style={{ color: 'var(--text2)', fontSize: 20 }}>
            ×
          </button>
        </div>

        {/* Presets */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {Object.keys(presets).map(p => (
            <button
              key={p}
              onClick={() => applyPreset(p)}
              style={{
                padding: '5px 12px',
                borderRadius: 20,
                fontSize: 12,
                fontWeight: 500,
                background: preset === p ? 'var(--accent)' : 'var(--bg3)',
                color: preset === p ? '#fff' : 'var(--text1)',
                border: `1px solid ${preset === p ? 'var(--accent)' : 'var(--line)'}`,
              }}
            >
              {p}
            </button>
          ))}
        </div>

        {field('Account Label', 'label', cfg, setCfg, 'text', 'Work Gmail')}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <div
              style={{
                color: 'var(--accent)',
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              IMAP (Incoming)
            </div>
            {field('Host', 'imapHost', cfg, setCfg, 'text', 'imap.gmail.com')}
            {field('Port', 'imapPort', cfg, setCfg, 'number', '993')}
            {field('Username', 'imapUser', cfg, setCfg, 'text', 'you@gmail.com')}
            {field('Password / App Password', 'imapPass', cfg, setCfg, 'password')}
          </div>
          <div>
            <div
              style={{
                color: 'var(--accent2)',
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              SMTP (Outgoing)
            </div>
            {field('Host', 'smtpHost', cfg, setCfg, 'text', 'smtp.gmail.com')}
            {field('Port', 'smtpPort', cfg, setCfg, 'number', '587')}
            {field('Username', 'smtpUser', cfg, setCfg, 'text', 'you@gmail.com')}
            {field('Password / App Password', 'smtpPass', cfg, setCfg, 'password')}
          </div>
        </div>

        {error && (
          <div style={{ color: 'var(--red)', fontSize: 13, margin: '12px 0' }}>{error}</div>
        )}

        <div style={{ display: 'flex', gap: 10, marginTop: 20, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '9px 20px',
              background: 'var(--bg3)',
              color: 'var(--text1)',
              borderRadius: 'var(--radius)',
            }}
          >
            Cancel
          </button>
          <button
            onClick={submit}
            disabled={loading}
            style={{
              padding: '9px 20px',
              background: 'var(--accent)',
              color: '#fff',
              borderRadius: 'var(--radius)',
              fontWeight: 600,
            }}
          >
            {loading ? 'Testing connection…' : 'Add Account'}
          </button>
        </div>
      </div>
    </div>
  );
}
